import { Navigation, Route } from '@ydegouvello/ui';
import { LoginComponent } from 'components/login.component';
import { SessionsRepository } from 'repositories/sessions.repository';

export class LoginRoute extends Route {
  private static _instance: LoginRoute | undefined = undefined;

  private constructor(
    location: string,
    readonly sessionsRepository: SessionsRepository,
    readonly navigation: Navigation,
  ) {
    super(location);
  }

  static getInstance(
    location: string = '/*',
    sessionsRepository: SessionsRepository = SessionsRepository.getInstance(),
    navigation: Navigation = Navigation.getInstance(),
  ): LoginRoute {
    this._instance ??= new this(location, sessionsRepository, navigation);
    return this._instance;
  }

  override async match(): Promise<boolean> {
    const session = await this.sessionsRepository.get();
    return !!session && !session.active;
  }

  override async getNewComponent(): Promise<LoginComponent> {
    return LoginComponent.getInstance();
  }
}
